module.exports = __webpack_public_path__ + "static/02-710f8c417e0a634415b7f4cc136c3bbc.jpg";